import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Cookies from "universal-cookie";
import menuBg from "../../assets/images/bg/menu/home.svg";
// images
import reload from "../../assets/images/icons/reload-black.svg";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { applyForPlan } from "./actions";
import { checkEmptyObject } from "../../utils/commonFunctions";
import "./style.scss";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { Button } from "react-bootstrap";

const cookie = new Cookies();

const ApplyForPlan = (props) => {
  const [openMenu, setOpenMenu] = useState(false);

  const handleSendEmailAgain = () => {
    props?.applyForPlan();
  };

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    if (!cookie.get("user_token")) {
      props.history.push("/login");
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!checkEmptyObject(props.user_info)) {
      if (props?.user_info?.subscription_type === "BASIC" || props?.user_info?.subscription_type === null) {
        props.history.push("/membership");
      }

      if (props?.user_info?.subscription_type !== cookie.get("user_info")?.subscription_type) {
        cookie.set("user_info", props?.user_info, {
          path: "/",
          expires: new Date(Date.now() + 3600 * 1000 * 24),
        });
      }
    }

    if (props?.user_info?.subscription_type === "PREMIUM" || props?.user_info?.subscription_type === "PRO") {
      props?.applyForPlan();
    }
  }, []);

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const processes = [
    {
      key: 1,
      title: "SIGN INTO THE ELEVATE TO WELLNESS PLATFORM",
      body: "Use the special code sent to your email address to log into the Elevate to Wellness Insurance Portal",
    },
    {
      key: 2,
      title: "Browse Plans for Free",
      body: "Cooperative members can view insurance plans on our website and the Elevate to Wellness platform.",
    },
    {
      key: 3,
      title: "Prepare Your Information and Apply",
      body: "Once you've found a plan you're interested in, you'll complete an application through the Elevate to Wellness platform.",
    },
    {
      key: 4,
      title: "GET YOUR INSURANCE",
      body: "If approved, you'll pay a one-time on-boarding fee to join the Elevate to Wellness Union.",
    },
  ];

  const checklists = [
    {
      key: 1,
      title: "Medical History",
      body: "Medical History and List of current medications (name and dosage)",
    },
    {
      key: 2,
      title: "Previous Insurance",
      body: "Your previous Health Insurance start and expiration dates",
    },
    {
      key: 3,
      title: "BANKING INFORMATION",
      body: "A bank name, account type, routing and account numbers for monthly ACH withdrawals to pay for your premiums (credit cards are not accepted)",
    },
    {
      key: 4,
      title: "Life Insurance",
      body: "For the included Life Insurance policy ($7K), your Beneficiary’s Name, Date of Birth and Social Security Number",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Confirm E-mail - Clarity Cooperative</title>
        <meta property="og:site_name" content="Clarity Cooperative" />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
      <div className="apply_for_plan">
        <div className="apply_for_plan_container">
          <div className="title_st">
            <p className="sub_title">It's Time To Apply</p>
            <h1>Check Your Email</h1>
          </div>
          <div className="confirm_email_area mb-3">
            <div className="check_spam">
              <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.16003 1H23.4457V19H1.16003V1Z" stroke="white" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  d="M1.16003 3.16846L11.1972 11.6387C11.5065 11.8998 11.8982 12.043 12.3029 12.043C12.7076 12.043 13.0993 11.8998 13.4086 11.6387L23.4457 3.16846"
                  stroke="white"
                  strokeWidth="1.71429"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Check Your Spam Folder
            </div>
            <div className="resend_email">
              Can’t find the e-mail?
              <strong onClick={handleSendEmailAgain}>
                Resend It <img src={reload} alt="reload" />
              </strong>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p className="sub_title">Our 4 Step Application Process:</p>
              <div className="flow_st">
                {processes.map((item) => (
                  <div className="singleinfo" key={item?.key}>
                    <div className="number">{item?.key}</div>
                    <div>
                      <h5>{item?.title}</h5>
                      <p>{item?.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <p className="sub_title mt-sm-40">Information Checklist:</p>
              <div className="checklist_st">
                <div className="triangle_icon" />
                {checklists?.map((item) => (
                  <div className="singleinfo" key={item?.key}>
                    <div className="icon">
                      <AiOutlineCheckCircle color="#7FD7F2" size={40} />
                    </div>
                    <div>
                      <h5>{item?.title}</h5>
                      <p>{item?.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-4">
            <a target="_blank" href="https://premierenroll.com/" rel="noreferrer">
              <Button>Go To Elevate To Wellnes</Button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user_info: state.my_account.user_info,
  is_loading: state.meta.isLoading,
});

export default connect(mapStateToProps, {
  // getAccountInformation,
  applyForPlan,
})(withRouter(ApplyForPlan));
